import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import { BWCMemberInformationForm } from "webapp/components/Partner/BWC/BWCMemberInformationForm/Index";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function BWCMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [isSelectedContact, setIsSelectedContact] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("BWC.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    const isSelected =
      selectedMember !== null && (typeof selectedMember === "object" || typeof selectedMember === "undefined");

    if (memberInfo && isSelected) {
      devLog("onMemberNext", memberInfo?.name);
      props.context.setState(
        {
          accountRef: memberInfo?.accountRef,
          contactRef: selectedMember ? selectedMember.contactRef : "",
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      setShowSelectUserModal(true);
      // props.context.setState(
      //   {
      //     MemberNumber: null,
      //     webAppState: AppState.ConfirmVehicle,
      //   },
      //   () => {}
      // );
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onUserSelectMember = (account, selectedContact) => {
    devLog("onUserSelectMember", account, selectedContact);
    setMemberInfo(account);
    setSelectedMember(selectedContact);
    const isSelected =
      selectedContact !== null && (typeof selectedContact === "object" || typeof selectedContact === "undefined");
    setIsSelectedContact(isSelected);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <BWCMemberInformationForm
          context={props.context}
          currState={props.currState}
          onSelect={onUserSelectMember}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
        />
      </div>

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}

export default BWCMemberInformation;
